import { useFormContext, useFormField } from '@cian/frontend-request-form-widget';
import { Select } from '@cian/ui-kit';
import * as React from 'react';
import { FormField } from '../../../components/FormField';
import { useFieldError } from '../../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectField = function SelectField(props) {
  var placeholder = props.placeholder,
    label = props.label,
    autoFocus = props.autoFocus,
    name = props.name,
    required = props.required,
    autoSubmit = props.autoSubmit,
    answersRaw = props.answers;
  var _useFormContext = useFormContext(),
    isSubmitting = _useFormContext.isSubmitting,
    handleSubmit = _useFormContext.handleSubmit;
  var _useFieldError = useFieldError(name),
    errorMessage = _useFieldError.errorMessage,
    hideError = _useFieldError.hideError;
  var answers = React.useMemo(function () {
    return answersRaw ? answersRaw : [];
  }, [answersRaw]);
  var _useFormField = useFormField({
      name: name
    }),
    _useFormField$field = _useFormField.field,
    _useFormField$field$v = _useFormField$field.value,
    value = _useFormField$field$v === void 0 ? '' : _useFormField$field$v,
    onBlur = _useFormField$field.onBlur,
    _useFormField$helpers = _useFormField.helpers,
    setValue = _useFormField$helpers.setValue,
    setError = _useFormField$helpers.setError;
  var handleChange = React.useCallback(function (value) {
    setValue(value);
    hideError();
    setError(undefined);
    if (autoSubmit) {
      /**
       * Не трогай таймаут - оно здесь надо.
       * Если значение поля еще не было установленно, без таймаута внутри
       * сабмит и не вызывается переход на следующий шаг (таймаут ставит макротаску в очередь с отсрочкой).
       * Видимо связанно с тем, что формик не успевает отследить/среагировать на изменения в своем стейте.
       * Ранее решалось хуком useCallFnAfterFormikChanged, но это вызывало баг при изменении значения поля
       * внутри формика (например при отмены перехода на следующий шаг со сбросом формы к предыдущему значению)
       * - повторный выбор "отмененного" варианта ответа "залипал" и форма не сабмитились.
       */
      setTimeout(handleSubmit, 0);
    }
  }, [setValue, hideError, setError, autoSubmit, handleSubmit]);
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    required: required,
    errorMessage: errorMessage,
    children: function children(_ref) {
      var id = _ref.id;
      return /*#__PURE__*/_jsx(Select, {
        id: id,
        name: name,
        value: value,
        disabled: isSubmitting,
        invalid: !!errorMessage,
        placeholder: placeholder,
        autoFocus: autoFocus,
        options: answers,
        onChange: handleChange,
        onBlur: onBlur
      });
    }
  });
};